module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card banner standard-card"
  }, [_c('h4', [_vm._v("Pobierz banery AC/OC")]), _vm._v(" "), _c('p', [_vm._v("Skopiuj kod banera i wklej na swoją stronę.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--full-width btn--cta-red",
    class: {
      active: _vm.isAc
    },
    on: {
      "click": function($event) {
        _vm.isAc = !_vm.isAc
      }
    }
  }, [(!_vm.isAc) ? _c('span', [_vm._v("Pokaż banery")]) : _c('span', [_vm._v("Ukryj banery")])]), _vm._v(" "), (_vm.isAc) ? _c('div', {
    staticClass: "banner-row"
  }, [_c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x125px v1",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x125px v2",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x125px v3",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x250px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x250.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "468x60px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_468x60.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "540x30px_v1",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "540x30px_v2",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "540x30px_v3",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "728x90px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_728x90.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "750x200px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_750x200.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "160x600px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_160x600.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x600px_v1",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x600.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x600px_v2",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x600-1.jpg"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card banner standard-card"
  }, [_c('h4', [_vm._v("Pobierz banery Travel")]), _vm._v(" "), _c('p', [_vm._v("Skopiuj kod banera i wklej na swoją stronę.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--full-width btn--cta-red",
    class: {
      active: _vm.isTravel
    },
    on: {
      "click": function($event) {
        _vm.isTravel = !_vm.isTravel
      }
    }
  }, [(!_vm.isTravel) ? _c('span', [_vm._v("Pokaż banery")]) : _c('span', [_vm._v("Ukryj banery")])]), _vm._v(" "), (_vm.isTravel) ? _c('div', {
    staticClass: "banner-row"
  }, [_c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "160x600px_v1",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "160x600px_v2",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "160x600px_v3",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "300x250px_v1",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "300x250px_v2",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "300x250px_v3",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "750x100px_v1",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "750x100px_v2",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "750x100px_v3",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w3.jpg"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card standard-card"
  }, [_c('h4', [_vm._v("Porównywarka ubezpieczeń na Twojej stronie internetowej")]), _vm._v(" "), _c('p', [_vm._v("White Label to porównywarka ubezpieczeń komunikacyjnych pod Twoją marką. Jeśli posiadasz stronę www i chcesz wzbogacić ją o porównywarkę - napisz "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v("partnerzy@punkta.pl")]), _vm._v(". Modele rozliczenia do uzgodnienia: Revenue Share, CPO, CPS.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51fe0bee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banners/banners.vue
// module id = 380
// module chunks = 0